import React, {Component} from 'react';
import {Alert, Button} from "antd";
import {withRouter} from 'react-router-dom';
import {stopPollingForPollables} from "./redux_actions/slides.action";
import {store} from "./helper/store";
import {clearAndAddSlidesToPoller} from "./redux_actions/dashboard.action";


class ConnectionStatus extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOnline: navigator.onLine,
            wasOffline: false,
            isGamma: this.props.location.pathname.includes('/gamma'),
        }

        this.isLocalSystem = window.location.hostname.includes('localhost') || window.location.hostname.includes('0.0.0.0');
    }

    componentDidMount() {
        if (!this.isLocalSystem) {
            window.addEventListener('online', this.handleOnline);
            window.addEventListener('offline', this.handleOffline);
        }
    }

    componentWillUnmount() {
        if (!this.isLocalSystem) {
            window.removeEventListener('online', this.handleOnline);
            window.removeEventListener('offline', this.handleOffline);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({isGamma: this.props.location.pathname.includes('gamma')});
        }
    }

    handleOnline = () => {
        this.setState({isOnline: true, wasOffline: true});
    };

    handleOffline = () => {
        store.dispatch(stopPollingForPollables());
        store.dispatch(clearAndAddSlidesToPoller([]));
        this.setState({isOnline: false});
    };

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.isLocalSystem) return;
        const {isGamma, wasOffline, isOnline} = this.state;

        return (
            <div className={"success-network-status"}
                 style={isGamma ? {position: 'fixed', bottom: 15, right: 15, zIndex: 9999} :
                     {position: 'fixed', top: 5, left: '40%', zIndex: 9999}}>
                {wasOffline && isOnline && (
                    <Alert
                        message=""
                        description={
                            <div>
                                You are back ONLINE. {isGamma && <br/>} Please reload the page to continue.
                                <Button size="small" type={'danger'} ghost onClick={this.handleReload}
                                        style={{marginLeft: 15}}>
                                    Reload
                                </Button>
                            </div>
                        }
                        type="success"
                        showIcon={isGamma}
                        closable
                        style={isGamma ? null : {padding: '4px 40px', fontSize: '12px'}}
                    />
                )}
                {!isOnline && (
                    <Alert
                        message={isGamma ? "Network Error" : ""}
                        description={
                            <div>
                                {!isGamma && <span style={{fontWeight: 'bold'}}>Network Error: </span>}
                                You are OFFLINE. {isGamma && <br/>}
                                Please check your internet connectivity.
                            </div>
                        }
                        type="error"
                        showIcon={isGamma}
                        style={isGamma ? null : {padding: '4px 35px', fontSize: '12px'}}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(ConnectionStatus);
